<template>
  <div class="city-contain" :style="{'height': rankList.length < 6 ? '100%' : isChartHeight ? '100%' : '200px'}">
    <div class="city-box" v-for="item in rankList" :key="item.id">
      <div class="city_top_title">
        <div class="city-name">{{item.city}}</div>
        <div class="mark">{{item.mark}}%</div>
      </div>
      <div class="right-box">
        <div class="line-box">
          <div class="line" :style="'width:' + item.mark + '%'"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
    export default {
        name: 'rankCharts',
        props: {
            'rankList': Array,
            isChartHeight: {
              type: Boolean,
              default: false
            }
        },
        data () {
            return {
                // maxWidth: '30px'
            }
        },
        mounted () {
        },
        beforeDestroy() {
          // this.rankList = null;
        },
        destroyed () {
          // this.rankList = null;

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.city-contain{
  width: 100%;
  padding: 0 16px 24px 16px;
  overflow: hidden;
  .city-box{
    width: 100%;
    .city_top_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 12px;
      font-weight: 400;
      color:rgba(51,51,51,1);
      line-height: 10px;
      color: #333;
      margin-bottom: 8px;
      margin-top: 16px;
      width: 100%;
      .city-name{
        width: 200px;
      }
      .mark{
      }
    }
    .right-box{
      // margin-bottom: 16px;
      width: 100%;
      .line-box{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        background:rgba(54,179,116,.2);
        .line{
          height: 6px;
          background: #36B374;
        }
      }
    }
  }
  .line_bottom:last-child::after{
    width: 0;
  }
}
</style>
